/**
 * Air theme JavaScript.
 */

// Define Javascript is active by changing the body class
document.body.classList.remove('no-js');
document.body.classList.add('js');

// Init lazyload
let images = document.querySelectorAll('.lazyload');
lazyload(images, {
     root: null,
     rootMargin: "0px",
     threshold: 0
});

// Debounce
function debounce(func, wait, immediate) {
  var timeout;
  return function() {
    var context = this, args = arguments;
    var later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};

// jQuery start
( function( $ ) {

  $(document).ready(function() {

    // Sticky kit
    var window_width = jQuery( window ).width();
    if (window_width < 1000) {
      jQuery('.order-information').trigger('sticky_kit:detach');
    } else {
      make_sticky();
    }

    jQuery( window ).resize(function() {

      window_width = jQuery( window ).width();

      if (window_width < 1000) {
        jQuery('.order-information').trigger('sticky_kit:detach');
      } else {
        make_sticky();
      }

    });

    function make_sticky() {
      jQuery('.order-information').stick_in_parent({
      });

      jQuery('.order-information').stick_in_parent({
      });
    }

    // Year popover on click/touch
    $('.trigger-year-popover').on('click', function(e) {
      e.preventDefault();
      $(this).toggleClass('is-selected');
      $('.year-popover').toggleClass('is-triggered');
    } );

    // Fix for Gutenberg gallery links to full size image
    // Find this pattern with regex: "-digits(n)xdigits(n)." then replace with a single dot
    var galleryLinks = document.querySelectorAll('.wp-block-gallery a');
    var i = 0;
    for ( i; i<galleryLinks.length; i++ ) {
      var imageLink = galleryLinks[i].href, regex = /-\d*x\d*./;
      galleryLinks[i].setAttribute('href', imageLink.replace(regex, '.'));
    }

    // Accessible drop down link list
    $(".dropdown-nav").accessibleDropDown();

    // Gallery
    var galleryelement = document.getElementsByClassName('wp-block-gallery')[0];
    if (typeof(galleryelement) != 'undefined' && galleryelement != null) {

      var galleryelements = document.getElementsByClassName('wp-block-gallery')
      for(var i = 0; i < galleryelements.length; i++) {

          galleryelements[i].onclick = function (event) {
            event = event || window.event;
            var target = event.target || event.srcElement,
            link = target.src ? target.parentNode : target,
            options = {
              index: link,
              event: event,
              fullScreen: false,
              toggleControlsOnSlideClick: false,
              stretchImages: 'cover',
              onopen: function (index, slide) {
                current = this.getIndex();
                total = this.getNumber();
                document.getElementById('pos').textContent = current + 1;
                document.getElementById('count').textContent = total;
              },
              onslide: function (index, slide) {
                current = this.getIndex();
                total = this.getNumber();
                document.getElementById('pos').textContent = current + 1;
                document.getElementById('count').textContent = total;
              }
            },
            links = this.getElementsByTagName('a');
            blueimp.Gallery(links, options);
          };

      }

    }
  });

  $.fn.accessibleDropDown = function() {
    $('a').focus(function() {
      $(this).parents('li').addClass('is-open');
    }).blur(function() {
      $(this).parents('li').removeClass('is-open');
    });

    $('a.first').on('click', function(e) {
      e.preventDefault();

      if ($(this).hasClass('clicked')) {
        $(this).removeClass('clicked');
        $(this).parents('li').removeClass('is-open');
      } else {
        $(this).toggleClass('clicked');
        $(this).parents('li').addClass('is-open');
      }

    }).blur(function() {
      $(this).removeClass('clicked');
      $(this).parents('li').removeClass('is-open');
    });
  }

	// Hide or show the "back to top" link
	$(window).scroll(function() {

    // Back to top
  	var offset = 300; // Browser window scroll (in pixels) after which the "back to top" link is shown
  	var offset_opacity = 1200; // Browser window scroll (in pixels) after which the link opacity is reduced
  	var scroll_top_duration = 700; // Duration of the top scrolling animation (in ms)
    var link_class = '.top';

		if( $(this).scrollTop() > offset ) {
      $( link_class ).addClass('is-visible');
    } else {
      $( link_class ).removeClass('is-visible');
    }

		if( $(this).scrollTop() > offset_opacity ) {
			$( link_class ).addClass('fade-out');
		} else {
      $( link_class ).removeClass('fade-out');
    }

	});

  // Document ready start
  $(function() {

    // Init responsive magazine
    var bookOptions = {
      width: 1400,
      height: 950,
      centeredWhenClosed: true,
      hardcovers: true,
      toolbar: "lastLeft, left, right, lastRight, zoomin, zoomout, fullscreen, thumbnails",
      thumbnailsPosition : 'bottom',
      responsiveHandleWidth: 50,
      container: window,
      flipSound: 0,
      containerPadding: "20px",
      toolbarContainerPosition: "top",
      pageNumbers: 0
    };

    $('#page').wowBook( bookOptions ); // Create the book

    // How to use wowbook API
    // var book=$.wowBook("#page"); // get book object instance
    // book.gotoPage( 4 ); // call some method

    // Overlay-search
    $('.menu-item-search a').on( 'click', function(e) {
      e.preventDefault();
      $('body').removeClass('main-navigation-open');
      $('body').removeClass('is-scrolling-prevented');
      $('.main-navigation').fadeOut(600);
      $('.main-navigation').removeClass('is-open');
      $('.overlay-search, body').addClass('overlay-open');
      $('body').addClass('search-open');
    } );

    $('.button-close').on( 'click', function() {
      $(this).parent().parent().parent('.overlay').removeClass('overlay-open');
      $('body').removeClass('overlay-open');
      $('body').removeClass('search-open');

      // Empty search on close
      $('.search-results > div').remove();
      jQuery('.search-mobile input').val(null);
      jQuery('.overlay-search input').val(null);
    } );

    // Search functions
    function search_fn( search ) {
      if ( search.length ) {
        var Result = {
          list: [],
          loadList: function() {
            return m.request( {
              method: 'GET',
              url: rest_api_settings.root + 'ark/v1/search?s=' + search,
              withCredentials: true,
            } )
            .then( function( result ) {
              Result.list = result;
            } )
          }
        }

        var ResultList = {
          oninit: Result.loadList,
          view: function() {
            return m( '.search-results', [
              m( 'ul', Result.list.map( function( result ) {

                return m( 'li', [
                  m( 'h2', { id: 'heading-' + result.ID, class: 'search-title underlined-hover' }, [
                    m( 'a', { href: result.link }, result.post_title ),
                  ] ),
                ] );
              } ) )
            ] )
          }
        }

        m.mount( document.getElementById('search-results'), ResultList );
      }
    }

    // debounce search
    var search_fn_debounced = debounce( function() {
      search_fn( jQuery(this).val().toLowerCase() );
    }, 250 );

    // trigger searh functionality
    jQuery('.overlay-search input').on( 'input', search_fn_debounced );

    // Set up back to top link
    var moveTo = new MoveTo();
    var target = document.getElementById('target');
    moveTo.move(target);

    // Register a back to top trigger
    var trigger = document.getElementsByClassName('js-trigger')[0];
    moveTo.registerTrigger(trigger);
  });

} )( jQuery );
